import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useRef,
} from "react";
import { getWebsocketBackendUrl } from "../api/backend.url";
import { useAuth } from "./auth.context.js";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const [message, setMessage] = useState();
  const [chatRead, setChatRead] = useState(false);
  const ws = useRef(null);
  const auth = useAuth();

  useEffect(() => {
    ws.current = new WebSocket(getWebsocketBackendUrl());
    ws.current.onopen = () => {
      console.log("websocket open");
    };

    ws.current.onmessage = (event) => {
      setMessage(JSON.parse(event.data));
      setChatRead(false);
    };

    ws.current.onclose = () => {};

    ws.current.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    return () => {
      ws.current.close();
    };
  }, [auth]);

  const setTokenOnWebsocket = (token) => {
    if (!ws.current) return;
    if (ws.current?.readyState === WebSocket.OPEN) {
      console.log("token set on websocket");
      ws.current.send(JSON.stringify({ type: "TEXT", token: token }));
    } else {
      ws.current.addEventListener(
        "open",
        () => {
          console.log("token set on websocket (delayed)");
          ws.current.send(JSON.stringify({ type: "TEXT", token }));
        },
        { once: true },
      );
    }
  };

  const removeTokenOnWebsocket = () => {
    if (ws.current?.readyState === WebSocket.OPEN) {
      ws.current.send(
        JSON.stringify({
          type: "TEXT",
          token: "LOGOUT",
        }),
      );
    }
  };

  return (
    <WebSocketContext.Provider
      value={{
        message,
        setChatRead,
        chatRead,
        setTokenOnWebsocket,
        removeTokenOnWebsocket,
      }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
